import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import { PaginatedResponse, RateUnitMapping } from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class RateUnitMappingsService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<RateUnitMapping>> {
        return this.apiService.get<any>('/rate-unit-mappings', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    edit(id: string, data: Record<string, any>): Observable<RateUnitMapping> {
        return this.apiService.patch<RateUnitMapping>(`/rate-unit-mappings/${id}`, data)
            .pipe(map(response => response.data));
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/rate-unit-mappings/export', params);
    }

    autocomplete(field: 'rate_unit' | 'rate_unit_mapped', query: string, context: Record<string, any> = {}) {
        return this.apiService.get<string[]>(
            `/rate-unit-mappings/autocomplete/${field}`,
            this.apiService.build({ q: query, ...context })
        );
    }
}
